import React from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import { formatPhoneNumber } from '@atc/string-fns';

import { Box, Text } from 'reaxl';
import {
    OwnerPhoneNumber,
    OwnerTextCTA,
} from 'reaxl-molecules';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import useDealerTextMessage from '@/hooks/useDealerTextMessage';

function LeadBox({
    children,
    disableContactCTAs = false,
    phoneAndTextHandler,
}) {

    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory) || {};
    const { owner = {} } = listing;
    const { phone = {}, textNumber } = owner;

    const {
        value = '',
        extension,
    } = phone;

    const textBody = useDealerTextMessage();

    const analyticsData = {
        inventoryId: listing?.id,
        ownerId: owner?.id,
        placement: 'snapshot',
    };

    const contactCtas = [];

    if (value && !disableContactCTAs) {
        contactCtas.push((
            <OwnerPhoneNumber
                key="lead-box-phone-cta"
                uiContext="iconbutton-horizontal"
                phone={phone}
                analyticsData={analyticsData}
                phoneClickHandler={phoneAndTextHandler}
                buttonLabel={`Call ${formatPhoneNumber(value, extension)}`}
            />
        ));
    }

    if (textNumber && !disableContactCTAs) {
        contactCtas.push((
            <OwnerTextCTA
                key="lead-box-text-cta"
                uiContext="iconbutton-horizontal"
                analyticsData={analyticsData}
                textClickHandler={phoneAndTextHandler}
                label="Text"
                phoneNumber={textNumber}
                textBody={textBody}
                className={clsx({
                    // helps with visual centering
                    'margin-right-6': !value,
                    'margin-right-5': value,
                })}
            />
        ));
    }

    return (
        <Box
            data-cmp="leadBox"
            backgroundColor="brand-primary"
            borderColor="info-200"
            className="display-flex flex-column flex-wrap text-center margin-bottom-5"
        >
            <Text
                size={400}
                weight="bold"
                className="margin-bottom-4"
            >
                Ready for Next Steps?
            </Text>
            {children}
            {contactCtas.length > 0 && (
                <div className="display-flex justify-content-around">
                    {contactCtas}
                </div>
            )}
        </Box>
    );
}

LeadBox.propTypes = {
    /**
     * Child elements to be rendered inside the LeadBox
     */
    children: PropTypes.node,
    /**
     * Boolean to disable phone/chat/email for the Hyundai experience
     */
    disableContactCTAs: PropTypes.bool,
    /**
     * Handler for phone and text cta
     */
    phoneAndTextHandler: PropTypes.func,
};

export default LeadBox;
